import { Heading, Stack, useToast } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  labToUserLab,
  useLabs,
  userLabsStore,
} from '../../../data/labsCollection'
import CenteredSpinner from '../../../components/CenteredSpinner'
import NotFound from '../../NotFound'
import useActiveUid from '../../../hooks/useActiveUid'
import UserLabTable from '../../../components/BloodWork/UserLabTable'
import { UserLab } from '../../../types/bloodWork'
import { useEffect, useState } from 'react'

export const prepareUserLabForSave = (userLab: UserLab, userId: string): UserLab => ({
  ...userLab,
  archived: false,
  userId,
})

export default () => {
  const { labTitle } = useParams()
  const navigate = useNavigate()
  const toast = useToast()
  const [userLab, setUserLab] = useState<UserLab>()

  const userId = useActiveUid()

  //Load Admin created lab to populate the UserLab
  const [labSnapshot, labFound] = useLabs({
    title: labTitle ?? '',
    isArchived: false,
  })

  useEffect(() => {
    if (labSnapshot && labSnapshot.length === 1 && userId && !userLab) {
      setUserLab(labToUserLab(labSnapshot[0].data(), userId))
    }
  }, [labSnapshot, userId, userLab])

  const onSubmit = async (userLab: UserLab) => {
    if (!userId) {
      toast({
        status: 'error',
        description: 'User not found. Please contact support.',
      })
      return
    }
    const preparedUserLab = prepareUserLabForSave(userLab, userId)
    console.log(preparedUserLab)
    const createdLab = await userLabsStore.add(preparedUserLab)
    navigate(`/labs/edit/${createdLab.id}`)
  }

  if (labFound === false) {
    return <NotFound />
  }

  if (!userLab) {
    return <CenteredSpinner />
  }

  return (
    userLab && (
      <Stack spacing={5}>
        <Heading>Add {userLab.title} Lab Test</Heading>
        <UserLabTable
          userLab={userLab}
          setUserLab={setUserLab}
          onSubmitFunc={onSubmit}
          submitButtonText={'Save'}
          submitButtonColorScheme='purple'
          cancelFunc={() => navigate('/labs')}
        />
      </Stack>
    )
  )
}
